export function createRealtimeSessionRepository(config) {
    const { repository, client } = config;
    const PREFIX = ['conversations', 'realtime', 'session'];
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id,
    ];
    return {
        useLookup(context, props, options) {
            const queryKey = getQueryKey(context);
            const query = repository.useQuery({
                ...options,
                queryKey: [...queryKey, props],
                async queryFn() {
                    const response = await client.realtimeSessionCreate({
                        realtimeSessionCreatePayload: props,
                    }, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    return response.data;
                },
            });
            return query;
        },
        useCreate(context) {
            const mutation = repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.realtimeSessionCreate({
                        realtimeSessionCreatePayload: props,
                    }, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    return response.data;
                },
            });
            return mutation;
        },
    };
}
//# sourceMappingURL=realtimeSessionRepository.js.map